import { render } from "./Specifications.vue?vue&type=template&id=2a9a8f14&scoped=true&ts=true&lang=pug"
import script from "./Specifications.vue?vue&type=script&lang=ts&setup=true"
export * from "./Specifications.vue?vue&type=script&lang=ts&setup=true"

import "./Specifications.vue?vue&type=style&index=0&id=2a9a8f14&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a8f14"]])

export default __exports__